<template>
  <v-dialog scrollable class="dialog" v-model="config.status.active" width="600">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat class="grey lighten-3 blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">申込みの確認</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat class="blue--text text--darken-2" @click="close">閉じる</v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-window v-model="config.pane">
          <v-window-item value="agreements">
            <div class="md-text text-xs-left">
              <AgreementsText />
            </div>
          </v-window-item>
          <v-window-item value="done">
              <div>
                <p class="body-1">
                  お申込みを承りました。<br />
                  現在、担当者が確認中です。
                </p>
                <v-btn depressed color="blue darken-2 white--text" @click.stop="close">完了</v-btn>
              </div>
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="config.pane === 'agreements'" class="grey lighten-3">
        <v-layout v-if="$vuetify.breakpoint.smAndUp" wrap row align-center class="px-3">
          <v-checkbox v-model="form.agree" color="blue darken-2" :label="'この規約に同意する'" />
          <v-spacer></v-spacer>
          <v-btn depressed class="blue darken-2 white--text"
            :loading="isLoading"
            :disabled="!isValid" @click.stop="submit">申込を確定する</v-btn>
        </v-layout>
        <v-layout v-else wrap row justify-end>
          <v-flex xs12>
            <v-checkbox v-model="form.agree" color="blue darken-2" :label="'この規約に同意する'" />
          </v-flex>
          <v-btn depressed class="blue darken-2 white--text"
            :loading="isLoading"
            :disabled="!isValid" @click.stop="submit">申込を確定する</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import marked from 'marked'
import AgreementsText from '@/assets/templates/markdown/agreements.md'
const DEF = {
  PANE: 'agreements'
}
export default {
  name: 'AgreementsModal',
  components: {
    AgreementsText
  },
  props: [
    'item'
  ],
  data () {
    return {
      config: {
        type: '',
        status: {
          active: false,
          loading: false
        },
        pane: DEF.PANE
      },
      meta: {
      },
      form: {
        valid: true,
        agree: false
      },
      store: {
        agreements: ''
      }
    }
  },
  methods: {
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    validate: function (status) {
      if (status == null) {
        this.$refs.form.validate()
      } else {
        this.$set(this.form, 'valid', status)
      }
    },
    submit: function () {
      if (
        this.$props.item &&
        this.$props.item.id
      ) {
        this.submitConfirm(this.$props.item)
        this.submitEmail(this.$props.item)
      }
    },
    submitConfirm: function (item) {
      this.$set(this.config.status, 'loading', true)
      this.axios.post(`${this.$url.api}user/apply/confirm/item/${item.id}`, {
      }, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
        this.$set(this.config.status, 'loading', false)
        if (res.data && res.data.success) {
          this.$emit('done', {
            id: item.id,
            status: 4
          })
          this.$set(this.config, 'pane', 'done')
        }
      })
    },
    submitEmail: function (item) {
      this.axios.post(`${this.$url.api}user/mail/confirm/apply/${item.id}`, {
      }, {
        headers: {
          'user-token': this.$localStorage.get('jwt')
        }
      }).then(res => {
        console.log(res)
      })
    },
    open: function () {
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        agree: false
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isValid () {
      return this.form.agree
    },
    isLoading () {
      return this.config.status.loading !== false
    },
    printAgreements () {
      return this.store.agreements ? marked(this.store.agreements) : ''
    }
  }
}
</script>

<style lang="scss">
</style>